module.exports = __webpack_public_path__ + "img/2.7130dff1.png";